import React from 'react';
import { X, Bell, ShieldAlert, AlertCircle, RefreshCw, CheckCircle2, ArrowRight } from 'lucide-react';

export default function NotificationDrawer({ isOpen, onClose, notifications = [], onRenew, onSelectDomain }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{ justifyContent: 'flex-end', padding: 0 }} onClick={onClose}>
      <div
        style={{
          width: '100%',
          maxWidth: '420px',
          height: '100vh',
          background: '#ffffff',
          borderLeft: '1px solid #e2e8f0',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '-10px 0 30px rgba(0, 0, 0, 0.1)',
          animation: 'slideLeft 0.25s cubic-bezier(0.16, 1, 0.3, 1)'
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          padding: '20px 24px',
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#f8fafc'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Bell size={20} color="#ea580c" />
            <h2 style={{ fontSize: '1.15rem', fontWeight: '700', color: '#0f172a' }}>
              Renewal Notifications ({notifications.length})
            </h2>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer' }}>
            <X size={20} />
          </button>
        </div>

        {/* List Body */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px' }}>
          {notifications.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text-muted)' }}>
              <CheckCircle2 size={48} color="#059669" style={{ marginBottom: '14px', opacity: 0.8 }} />
              <h3 style={{ fontSize: '1.1rem', color: '#0f172a', marginBottom: '6px' }}>All Domains Healthy!</h3>
              <p style={{ fontSize: '0.85rem' }}>No domains require urgent renewal at this moment.</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              {notifications.map(item => {
                const days = item.daysRemaining;
                const isExpired = days <= 0;
                const isUrgent = days > 0 && days <= 7;

                return (
                  <div
                    key={item.id}
                    className="glass-panel"
                    style={{
                      padding: '16px',
                      borderColor: isExpired ? '#fecaca' : isUrgent ? '#ffedd5' : '#fde68a',
                      background: isExpired ? '#fef2f2' : isUrgent ? '#fff7ed' : '#fffbeb'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '8px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {isExpired ? <AlertCircle size={16} color="#dc2626" /> : <ShieldAlert size={16} color="#ea580c" />}
                        <strong style={{ color: '#0f172a', fontSize: '0.98rem' }}>{item.domainName}</strong>
                      </div>
                      <span className={`badge badge-${item.computedStatus}`}>
                        {isExpired ? 'Expired' : `${days}d left`}
                      </span>
                    </div>

                    <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '12px' }}>
                      Registrar: <span style={{ color: '#0f172a', fontWeight: '600' }}>{item.registrar}</span> • Due Date: <span style={{ color: '#0f172a', fontWeight: '600' }}>{item.renewalDate}</span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                      <button
                        className="btn btn-renew"
                        style={{ padding: '6px 12px', fontSize: '0.8rem', flex: 1 }}
                        onClick={() => onRenew(item.id)}
                      >
                        <RefreshCw size={13} /> Renew (+1 yr)
                      </button>

                      <button
                        className="btn btn-secondary"
                        style={{ padding: '6px 10px', fontSize: '0.8rem' }}
                        onClick={() => { onClose(); onSelectDomain(item); }}
                      >
                        Details <ArrowRight size={13} />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
